'use strict';

angular.module('user', [
    'event',
    'portal.i18n',
    'sharecrf-sdk',
    'sharecrf-url',
]);
